<template>
  <div id="app">
    <transition name="slide-fade" mode="out-in" v-on:before-enter="beforeEnter" v-on:after-enter="afterEnter">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import CV from "./components/CV";
import Main from "./components/Main";
export default {
  name: 'App',
  components: { Main, CV },
  methods: {
    beforeEnter: function (el) {
         $('body').css('overflow', 'hidden');
    },
    afterEnter: function (el) {
         $('body').css('overflow', 'auto');
    }
  }
}
</script>

<style>
#app {
}

body {
  /*overflow: hidden;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue